import React from 'react'
import '../App.css'
function Contact() {
  return (
    <>
      <div style={{textAlign:'center'}}>
      <h2 className='serv mb-4'>Contact Us</h2>
        <p className='vall'><i class="fa-solid fa-building-columns"></i> Vallikunnil Medicals</p>
        <p className='vall1'><i class="fa-solid fa-address-card"></i> Kulanada (P.O) kulanada</p>
        <p className='vall1'><i class="fa-solid fa-location-dot"></i> near T.B junction kulanada</p>
        <p className='vall1'><i class="fa-solid fa-envelope"></i> vallikunnilmedicals@gmail.com</p>
        <p className='vall1'><i class="fa-solid fa-phone"></i>+91 9961750288</p>
      </div>
      <div>
      <div className='ratediv'>
        <marquee  behavior="alternate" direction=""><span><a className='rateh5' target='_bind' href="https://g.page/r/CQC55sVFSbheEB0/review"><i class="fa-bounce fa-beat-fade fa-regular fa-circle-right"></i> Help us to improve by giving your feedback <i class="fa-bounce fa-beat-fade fa-regular fa-circle-left"></i></a></span></marquee>
      </div>
      <iframe className='iframemap ' src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3938.0078847338395!2d76.66943767418519!3d9.243592290826552!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b061709332d4a93%3A0x5eb84945c5e6b900!2sVallikunnil%20Medicals!5e0!3m2!1sen!2sin!4v1716311070673!5m2!1sen!2sin" width="600" height="450" style={{border:0}} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
      </div>
    </>

  )
}

export default Contact